<section class="monitoring card">
  <div class="card__header">
    <h3 class="card__title">{{ 'INSTANCE_DETAILS.MONITORING' | transloco }}</h3>
    <button class="btn-link mat-headline-6 fw-700 flex justify-center items-center" (click)="refreshMonitoring()">
      <mat-icon svgIcon="refresh" class="mr-12" [@rotate]="count"></mat-icon>
      {{ 'BLUEPRINT_SUMMARY.REFRESH_INSTANCE' | transloco }}
    </button>
  </div>

  <!-- skeleton while loading -->
  <div class="health-card mt-16" *ngIf="isLoading">
    <div class="donut-section skeleton-box">
      <ngx-skeleton-loader class="skeleton-donut" appearance="circle"></ngx-skeleton-loader>
    </div>
    <div class="content-section p-16">
      <ngx-skeleton-loader class="skeleton-header" count="1" appearance="line"></ngx-skeleton-loader>
      <ngx-skeleton-loader class="skeleton-row" count="6" appearance="line"></ngx-skeleton-loader>
    </div>
  </div>


  <div class="health-card mt-16" *ngIf="!isLoading && !noMonitoringData && nonProdZone as zone">
    <div class="donut-section">
      <div class="donut" [ngStyle]="zone.donutStyle" [@donutAnimation]="donutAnimationState">
        <div class="donut-center">
          <div class="fs-32 fw-500 font-color">{{ zone.services }}</div>
          <div class="fs-20 fw-400 font-color">{{ 'INSTANCE_DETAILS.SERVICES' | transloco }}</div>
        </div>
      </div>
    </div>

    <div class="content-section">
      <div class="status-row pl-24">
        <div class="status healthy" [class.active]="activeStatus === 'HEALTHY'" (click)="onStatusChange('HEALTHY')">
          {{ 'INSTANCE_DETAILS.HEALTHY' | transloco }}
          <span class="badge">{{ zone.healthy }}</span>
        </div>
        <div class="status impacted" [class.active]="activeStatus === 'IMPACTED'" (click)="onStatusChange('IMPACTED')">
          {{ 'INSTANCE_DETAILS.IMPACTED' | transloco }}
          <span class="badge">{{ zone.impacted }}</span>
        </div>
        <div class="status critical" [class.active]="activeStatus === 'CRITICAL'" (click)="onStatusChange('CRITICAL')">
          {{ 'INSTANCE_DETAILS.CRITICAL' | transloco }}
          <span class="badge">{{ zone.critical }}</span>
        </div>
      </div>

      <div class="inner-panel mb-12">
        <div class="left-panel-rag flex flex-col">
          <div class="app-tag" *ngFor="let item of getFilteredItems(zone)" [class.active]="selectedItem === item"
            (click)="selectItem(item)">
            {{ item.product }}
          </div>
          <div class="empty p-12" *ngIf="getFilteredItems(zone).length === 0">No services</div>
        </div>
        <div class="flex flex-col ml-12 width-right">
          <div *ngIf="selectedItem?.summary" class="system-status"
            [ngClass]="ragToStatus(selectedItem.rag).toLowerCase()">
            {{ selectedItem.summary }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isLoading && (noMonitoringData || !nonProdZone)" class="flex flex-col items-center mb-10 pt-60 pb-60">
    <mat-icon svgIcon="inventory_2" class="no-release-color icon-lg mr-12"></mat-icon>
    <div class="no-data">{{ 'INSTANCE_DETAILS.NO_SERVICE_AVAILABLE' | transloco }}</div>
  </div>
</section>